import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { setActiveTourItem } from "store/whatsNewSlice";
import { IWhatsNewItem } from "api/whatsNew/whatsNew.type";
import { AnalyticsEvent } from "utils";

// Shared "open a What's New item" behavior for the panel and the See-all page: track the click, arm
// the feature modal with the item, then navigate to its page (the global FeatureTourModal pops it
// once the page lands). The BE marks items seen via the watermark set when the panel opens, not here.
export const useOpenWhatsNewItem = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return useCallback(
    (item: IWhatsNewItem, source = "panel") => {
      AnalyticsEvent("whats_new_item_click", "", "click", { item: item.id, source });
      dispatch(setActiveTourItem(item));
      if (item.link) navigate(item.link);
    },
    [navigate, dispatch]
  );
};

export default useOpenWhatsNewItem;
